var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutcomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Goal_2_Icon",
    "data-name": "Goal 2 Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3521",
    "data-name": "Rectangle 3521",
    width: 32,
    height: 32,
    rx: 7,
    transform: "translate(0 32) rotate(-90)",
    fill: "#ddd",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Goal_2_Icon-2",
    "data-name": "Goal 2 Icon",
    d: "M11.6,35.151H8.884a1.5,1.5,0,0,1-1.3-2.255l4.039-7a1.5,1.5,0,0,1,2.608,0l.294.51-3.136,5.429a2.965,2.965,0,0,0,0,2.992,2.826,2.826,0,0,0,.213.319ZM31.18,32.9,27.141,25.9a1.509,1.509,0,0,0-2.613,0l-.294.51,3.141,5.429a2.965,2.965,0,0,1,0,2.992,2.826,2.826,0,0,1-.213.319h2.716a1.5,1.5,0,0,0,1.3-2.255ZM20.308,28.288c.135-.211.308-.563.434-.818a5.96,5.96,0,0,1,1.5-2.173l-1.29-2.232h0a1.777,1.777,0,0,0-.985-.81V21h3.8a.586.586,0,0,0,.454-.956l-1.241-1.537,1.241-1.54h0a.586.586,0,0,0-.454-.952H19.381a.585.585,0,0,0-.586.586v5.658a1.777,1.777,0,0,0-.985.809l-1.728,2.992c1.246.317,3.317.991,4.227,2.232Zm6.054,4.139-3.52-6.1a5.816,5.816,0,0,0-1.044,1.66c-.426.88-.76,1.554-1.42,1.6h-.07A1.136,1.136,0,0,1,19.39,29c-.686-.98-2.713-1.622-3.919-1.9L12.4,32.427a1.815,1.815,0,0,0,1.575,2.724H24.787a1.815,1.815,0,0,0,1.575-2.724Z",
    transform: "translate(-3.381 -10.011)",
    fill: "#ff71b8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutcomeIcon);
export default __webpack_public_path__ + "static/media/outcomeIcon.bdf0c1fd631a4cef864d8d0eb6124bcc.svg";
export { ForwardRef as ReactComponent };